import moment from 'moment';

const InvoiceMonthliesAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    period: moment(i.period).format('DD MMMM YYYY'),
    'companies.title': i.company?.name,
    periodNormal: i.period,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default InvoiceMonthliesAdapter;
